import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template as FooterTemplate } from "../footer";

export default {
    title: "Shared/Footer",
    render: FooterTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
